<template>
  <div class="portalApplication">
    <el-table :data="tableData" tooltip-effect="light" style="width: 100%" :empty-text="currentLanguage.emptyText">
      <el-table-column
        :label="currentLanguage.appname"
        prop="clientName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        :label="currentLanguage.appurl"
        prop="rootUrl"
        class-name="rootUrl"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span @click="openUrl(scope.row.rootUrl)">{{
            scope.row.rootUrl
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enable"
        :label="currentLanguage.appstate"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch :value="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
  </div>
</template>

<script>  
import language from "@/assets/messages/language"
import APIS from "@/apis/clientManage.js"
let currentLanguage = {}

export default {
  data() {
    return {
      tableData: [],
      enterpriseId: "",
      breadcrumb: [
        {
          label: currentLanguage.apptitle
        }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentClientId: "",
      accountName: ""
    }
  },
  computed: {
    // 404页面不展示导航菜单
    currentLanguage() {
      currentLanguage = language.languageJson[this.$store.state.currentLanguage]
      return currentLanguage
    }
  },
  created() {
    try {
      this.accountName = this.$keycloak.tokenParsed.preferred_username
    } catch (error) {
      console.log(error)
    }
  },
  mounted() {
    if (this.accountName && this.realmName) {
      this.getClientList()
    }
  },
  methods: {
    // 查询账户列表
    async getClientList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      let { status, data } = await APIS.getPortalClients(
        this.realmName,
        this.accountName,
        {
          params
        }
      )
      this.total = 0
      this.tableData = []
      if (status === 0) {
        this.total = data.totalCount || 0
        this.tableData = []
        if (data && data.data) {
          this.tableData = data.data.map((item, index) => {
            return {
              index: index,
              clientName: item.name,
              rootUrl: item.rootUrl,
              enable: item.enabled,
              clientID: item.clientId,
              id: item.id
            }
          })
        }
      }
    },
    // 翻页
    pageChange(currentPage) {
      this.pageNum = currentPage
      this.getClientList()
    },
    openUrl(url) {
      window.open(url, "_blank")
    }
  }
}
</script>

<style lang="scss">
.portalApplication {
}
</style>
